import {
  FETCH_ALL_CHAIR_RENTALS,
  FETCH_CHAIR_RENTAL,
  FETCH_CHAIR_RENTAL_PAYMENT_HISTORY,
  FETCH_SINGLE_CHAIR_RENTAL_PAYMENT,
} from './constants';
import { combineReducers } from 'redux';

const chairRentals = (state = [], action) => {
  switch (action.type) {
    case FETCH_ALL_CHAIR_RENTALS:
      return action.payload;
    case FETCH_CHAIR_RENTAL:
      return state.map((item) => {
        if (item.barberId === action.payload.barberId) {
          return action.payload;
        }

        return item;
      });
    default:
      return state;
  }
};

const paymentHistory = (state = [], action) => {
  switch (action.type) {
    case FETCH_CHAIR_RENTAL_PAYMENT_HISTORY:
      return action.payload;
    case FETCH_SINGLE_CHAIR_RENTAL_PAYMENT:
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }

        return item;
      });
    default:
      return state;
  }
};

export default combineReducers({
  items: chairRentals,
  paymentHistory,
});
